import {TimesheetEmployeeHoursReport} from "../../models/reporting/TimesheetEmployeeHoursReport";
import {
    errorFetchingRequestState,
    getInitialRequestState,
    RequestState,
    startFetchingRequestState, successFetchingRequestState
} from "../../models/common/RequestState";
import {
    FETCH_MENU_TIMESHEET_HOURS_REPORT,
    FETCH_MENU_TIMESHEET_HOURS_REPORT_ERROR,
    FETCH_MENU_TIMESHEET_HOURS_REPORT_SUCCESS,
    FETCH_TIMESHEET_HOURS_REPORT,
    FETCH_TIMESHEET_HOURS_REPORT_ERROR,
    FETCH_TIMESHEET_HOURS_REPORT_SUCCESS,
    TimesheetReportActionTypes
} from "../../actions/reporting/TimesheetReportActions";
import {DateRange} from "../../models/common/DateRange";
import {UserId} from "../../models/users/AuthenticatedUser";
import {formatDbDate} from "../../helpers/DateTimeHelpers";
import {Nullable} from "../../models/common/Nullable";

export function createEmployeeHoursReportKey( userId: UserId, dateRange: DateRange ) {
    if( typeof userId === "undefined" ) {
        return "noAuth";
    }

    return `${userId.rawValue}_${formatDbDate(dateRange.start)}_${formatDbDate(dateRange.endInclusive)}`;
}

export interface TimesheetReportState {
    employees: {
        totalEntries: number
        entries: Nullable< TimesheetEmployeeHoursReport[] >,
        request: RequestState
    }

    authUserHoursByWeek: {
        entry: { [ key: string ]: Nullable< TimesheetEmployeeHoursReport > }
        request: RequestState
    }

}
export const initialState: TimesheetReportState = {
    employees: {
        totalEntries: 0,
        entries: null,
        request: getInitialRequestState()
    },
    authUserHoursByWeek: {
        entry: {},
        request: getInitialRequestState()
    }
};

export function TimesheetReportReducer( state = initialState, action: TimesheetReportActionTypes ) {

    switch( action.type ) {
        case FETCH_TIMESHEET_HOURS_REPORT:
            return {
                ...state,
                employees: {
                    totalEntries: 0,
                    entries: null,
                    request: startFetchingRequestState()
                }
            };
        case FETCH_TIMESHEET_HOURS_REPORT_SUCCESS:
            return {
                ...state,
                employees: {
                    totalEntries: action.reports.totalEntries,
                    entries: action.reports.entries,
                    request: successFetchingRequestState()
                }
            };
        case FETCH_TIMESHEET_HOURS_REPORT_ERROR:
            return {
                ...state,
                employees: {
                    ...state.employees,
                    request: errorFetchingRequestState( action.error )
                }
            };

        case FETCH_MENU_TIMESHEET_HOURS_REPORT: {
            const reportKey = createEmployeeHoursReportKey(action.userIds[0], action.dateRange);
            return {
                ...state,
                authUserHoursByWeek: {
                    entry: { [ reportKey ]: null},
                    request: startFetchingRequestState()
                }
            };
        }
        case FETCH_MENU_TIMESHEET_HOURS_REPORT_SUCCESS: {
            const report = action.reports.entries[ 0 ];
            const reportKey = createEmployeeHoursReportKey( report.employee.userId, report.dateRange);
            return {
                ...state,
                authUserHoursByWeek: {
                    entry: { [ reportKey ]: report },
                    request: startFetchingRequestState()
                }
            };
        }
        case FETCH_MENU_TIMESHEET_HOURS_REPORT_ERROR: {
            return {
                ...state,
                authUserHoursByWeek: {
                    ...state.authUserHoursByWeek,
                    request: errorFetchingRequestState(action.error)
                }
            };
        }
        default:
            return state;
    }
}